const ONE_HOUR_MS = 60 * 60 * 1000
const THIRTY_MINUTES_MS = 30 * 60 * 1000
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

export const UTM_CONFIGS = {
  core: {
    storageKey: 'utmsV2',
    utms: [
      'campaign',
      'medium',
      'source',
      'content',
    ],
    ttl: SEVEN_DAYS_MS,
  },
  business: {
    storageKey: 'utmsBusiness',
    utms: [
      'bp',
      'ruleId',
      'userChoseDates',
    ],
    ttl: ONE_HOUR_MS,
  },
  clickIdentifiers: {
    storageKey: 'utmClickID',
    utms: [
      'gclid',
      'fbclid',
      'irclickid',
      'r',
      'sid',
    ],
    ttl: THIRTY_MINUTES_MS,
  },
}
